// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/builds/litta-front/litta-palmer/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelDashboard0 from '/builds/litta-front/litta-palmer/src/models/dashboard.js';
import ModelGlobal1 from '/builds/litta-front/litta-palmer/src/models/global.js';
import ModelIndex2 from '/builds/litta-front/litta-palmer/src/models/live/channel/index.js';
import ModelIndex3 from '/builds/litta-front/litta-palmer/src/models/live/index.js';
import ModelIndex4 from '/builds/litta-front/litta-palmer/src/models/live/liveContentLibrary/index.js';
import ModelIndex5 from '/builds/litta-front/litta-palmer/src/models/live/livePreview/index.js';
import ModelLogin6 from '/builds/litta-front/litta-palmer/src/models/login.js';
import ModelReport7 from '/builds/litta-front/litta-palmer/src/models/report.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'dashboard', ...ModelDashboard0 });
app.model({ namespace: 'global', ...ModelGlobal1 });
app.model({ namespace: 'index', ...ModelIndex2 });
app.model({ namespace: 'index', ...ModelIndex3 });
app.model({ namespace: 'index', ...ModelIndex4 });
app.model({ namespace: 'index', ...ModelIndex5 });
app.model({ namespace: 'login', ...ModelLogin6 });
app.model({ namespace: 'report', ...ModelReport7 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
